import { cloneDeep } from "lodash";

// Components
import TradesContent from "./Trades/TradesContent";
import SalesContent from "./Sales/SalesContent";
import BonusDepartments from "@/PayPlans/components/Commons/BonusDepartments";
import OperationCodes from "@/PayPlans/components/Commons/OperationCodes";

// Types
import { TAction, EActionType } from "../reducer";
import { ESpiffTypes, IEligibilityRequirement, OnActionUpdateParams } from "../../../types/spiffSetup";
import { TErrors } from "../validation";
import { IOEM } from "@/Common/interfaces/location";
import GpsContent from "./GPSCompliance/GpsContent";
import { Box } from "@mui/material";
import { IVariableOperationsGpsBonusSetup } from "@/PayPlans/types/sections/variableOperationsGpsBonus";

interface IEditModeContentProps {
	spiffType: string;
	eligibilityRequirements: IEligibilityRequirement | IVariableOperationsGpsBonusSetup;
	updateEligibilityRequirements: (updatedState: TAction) => void;
	errors: TErrors;
	useSectionsErrors?: () => any;
	oems: IOEM[];
}

const EditModeContent = (props: IEditModeContentProps) => {
	const { spiffType, eligibilityRequirements, updateEligibilityRequirements, errors, oems, useSectionsErrors } = props;

	if (spiffType === ESpiffTypes.GPS_COMPLIANCE) {
		return (
			<Box className="!min-w-[1140px] !min-h-[450px]">
				<GpsContent
					eligibilityRequirements={eligibilityRequirements as IVariableOperationsGpsBonusSetup}
					updateEligibilityRequirements={updateEligibilityRequirements}
					errors={errors}
					useSectionsErrors={useSectionsErrors}
				/>
			</Box>
		);
	}

	if (spiffType === ESpiffTypes.SALES) {
		return (
			<SalesContent
				rules={(eligibilityRequirements as IEligibilityRequirement).rules ?? []}
				tiers={(eligibilityRequirements as IEligibilityRequirement).tiers ?? []}
				pvrType={(eligibilityRequirements as IEligibilityRequirement).pvrType ?? ""}
				requiredStoreUnits={(eligibilityRequirements as IEligibilityRequirement).requiredStoreUnits}
				requiredPvr={(eligibilityRequirements as IEligibilityRequirement).requiredPvr}
				applyTiersRetroactively={(eligibilityRequirements as IEligibilityRequirement).applyTiersRetroactively}
				updateEligibilityRequirements={updateEligibilityRequirements}
				errors={errors}
				franchises={(eligibilityRequirements as IEligibilityRequirement)?.franchises ?? []}
			/>
		);
	}

	const onActionUpdate = (value: OnActionUpdateParams) => {
		if (value.isValid) {
			const payload = cloneDeep(value.modelToPropagate);
			updateEligibilityRequirements({ type: EActionType.UPDATE_ALL, payload });
		}
	};

	if (spiffType === ESpiffTypes.DEPARTMENT) {
		return (
			<BonusDepartments
				sectionId={"SpiffSetup"}
				tabKey={"departments"}
				content={eligibilityRequirements as IEligibilityRequirement}
				readOnly={false}
				onActionUpdate={onActionUpdate}
				container={false}
			/>
		);
	}

	if (spiffType === ESpiffTypes.OP_CODES) {
		return (
			<OperationCodes
				sectionId={"SpiffSetup"}
				tabKey={"operationCodes"}
				content={eligibilityRequirements as IEligibilityRequirement}
				readOnly={false}
				onActionUpdate={onActionUpdate}
				container={false}
			/>
		);
	}

	return (
		<TradesContent
			oems={oems ?? []}
			pvrType={(eligibilityRequirements as IEligibilityRequirement).pvrType ?? ""}
			tiers={(eligibilityRequirements as IEligibilityRequirement).tiers}
			applyTiersRetroactively={(eligibilityRequirements as IEligibilityRequirement).applyTiersRetroactively}
			updateEligibilityRequirements={updateEligibilityRequirements}
			franchises={(eligibilityRequirements as IEligibilityRequirement)?.franchises ?? []}
		/>
	);
};

export default EditModeContent;
